














import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'GTitleBar',
  computed: {},
  methods: {},
})
export default class GTitleBar extends mixins(GPageBase) {
  mounted() {}
}
